export default {
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error'
}
